import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { map } from 'rxjs/operators';
import { ProductoActividadCampo } from '../_models/producto-actividad-campo';

@Injectable({
  providedIn: 'root'
})
export class ProductoActividadCampoService {
  private rutServicio = AppSettings.rutServiciosAPL + '/api/productosSegmentosFuncionalidadesControles';

  constructor( private httClient: HttpClient, private autServicio: AutenticacionService ) {
  }

  listado() {
    return this.httClient.get( this.rutServicio ).pipe( map( res => res as ProductoActividadCampo[] ) );
  }

  listadoHabilitados() {
    return this.httClient.get( this.rutServicio + '/enabled' ).pipe( map( res => res as ProductoActividadCampo[] ) );
  }

  listadoPorProductoActividad( idProducto: string ) {
    return this.httClient.get( this.rutServicio + '/productoSegmento/' + idProducto ).pipe( map( res => res as ProductoActividadCampo[] ) );
  }

  obtenerPorId( id: string ) {
    return this.httClient.get( this.rutServicio + '/' + id ).pipe( map( res => res as ProductoActividadCampo ) );
  }

  crear( regCrear: ProductoActividadCampo ) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutServicio, regCrear ).pipe( map( res => res as ProductoActividadCampo ) );
  }

  actualizar( regActualizar: ProductoActividadCampo ) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.put( this.rutServicio, regActualizar ).pipe( map( res => res as any ) );
  }

  bulk( regActualizar: ProductoActividadCampo[] ) {
    regActualizar.map( ( s: ProductoActividadCampo ) => {
      s.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    } );
    return this.httClient.post( this.rutServicio + '/bulk', regActualizar ).pipe( map( res => res as any ) );
  }
}
